<template>
  <ag-modal-container
    title="Ajouter une catégorie d'opération"
    width="800px"
    @close="back"
  >
    <operationCategory-form
      v-model="value"
      @validate="isValid = $event"
    />

    <template v-slot:footer>
      <v-spacer />
      <v-btn
        :loading="loading"
        :disabled="!isValid"
        color="accent"
        class="ml-5"
        @click="create"
        v-text="'Ajouter'"
      />
    </template>
  </ag-modal-container>
</template>

<script>
import { mapActions } from 'vuex'
import Repositories from 'src/repositories'

import AgModalContainer from 'src/components/common/AgModalContainer'
import OperationCategoryForm from '../components/OperationCategoryForm'

export default {
  name: 'OperationCategoryCreateContainer',
  components: {
    AgModalContainer,
    OperationCategoryForm,
  },
  data: () => ({
    isValid: false,
    loading: false,
    value: {
      name: '',
      operationTypeList: [],
      rejectionCauseList: [],
    },
  }),
  methods: {
    ...mapActions('ui', {
      showSuccessNotification: 'showSuccessNotification',
      showErrorNotification: 'showErrorNotification',
    }),
    back () {
      this.$router.back()
    },
    async create () {
      this.loading = true
      try {
        await Repositories.operationCategory.post(this.value)
        this.showSuccessNotification(`La catégorie d'opération ${this.value.name} a bien été créé`)
        this.back()
      }
      catch (error) {
        this.showErrorNotification(Repositories.parseErrorMessage(error))
      }
      finally {
        this.loading = false
      }
    },
  },
}
</script>
